if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('service-worker.js').then(function(registration) {
        console.log('Service Worker registered');
    }).catch(function(err) {
        console.log('Service Worker registration failed: ', err);
    });
}

var portalName = extractPortalName();
if (portalName !== '') {
    inject('clients/' + portalName + '/styles/styles.css');
} else { //localhost
    inject('clients/default/styles/styles.css');
}

function extractPortalName() {
  var hostname = location.hostname;
  var reg = /portal-(.*)\.bigredsky\.com/g;
  var ret = reg.exec(hostname);
  if (Array.isArray(ret) && ret.length) {
    //return hostname;
    return ret[1];
  } else {
    return hostname;
  }
}

function inject(styleUrl) {
    var sNew = document.createElement("link");
    //sNew.async = true;
    sNew.rel = 'stylesheet';
    sNew.href = styleUrl;
    sNew.id = 'portal-theme';
    var s0 = document.getElementsByTagName('link')[0];
    s0.parentNode.insertBefore(sNew, s0);
}



// WEBPACK FOOTER //
// src/init.js